import React from 'react';
import { Mail } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

const SendgridTab = ({
  sendgridSettings,
  setSendgridSettings,
  onSave,
  savingSendgrid,
  sendgridTestEmail,
  setSendgridTestEmail,
  onTest,
  testingSendgrid,
}) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Mail className="h-5 w-5" /> SendGrid Email Service
      </CardTitle>
      <p className="text-sm text-gray-500">Configure SendGrid as your email provider. Existing keys stay protected; leave this field blank when only changing sender details.</p>
    </CardHeader>
    <CardContent className="space-y-4">
      <div>
        <label className="block text-sm font-medium mb-1">API Key *</label>
        <Input
          type="password"
          value={sendgridSettings.api_key}
          onChange={(e) => setSendgridSettings((prev) => ({ ...prev, api_key: e.target.value }))}
          placeholder={sendgridSettings.api_key_masked || 'SG.xxxxxxxx...'}
          data-testid="sendgrid-api-key"
        />
        <p className="text-xs text-gray-500 mt-1">A saved key is masked and preserved. Paste a value only when replacing it with a newly created SendGrid key.</p>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">From Email</label>
          <Input
            value={sendgridSettings.from_email}
            onChange={(e) => setSendgridSettings((prev) => ({ ...prev, from_email: e.target.value }))}
            placeholder="noreply@dayefarmltd.com"
            data-testid="sendgrid-from-email"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">From Name</label>
          <Input
            value={sendgridSettings.from_name}
            onChange={(e) => setSendgridSettings((prev) => ({ ...prev, from_name: e.target.value }))}
            placeholder="Daye Farm Ltd"
            data-testid="sendgrid-from-name"
          />
        </div>
      </div>
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={sendgridSettings.enabled}
          onChange={(e) => setSendgridSettings((prev) => ({ ...prev, enabled: e.target.checked }))}
          className="rounded"
        />
        <span className="text-sm">Enable SendGrid</span>
      </label>
      <div className="flex gap-2">
        <Button onClick={onSave} disabled={savingSendgrid} data-testid="save-sendgrid-btn">
          {savingSendgrid ? 'Saving...' : 'Save Settings'}
        </Button>
      </div>
      <div className="border-t pt-4 mt-4">
        <h4 className="text-sm font-semibold mb-2">Test SendGrid</h4>
        <div className="flex gap-2">
          <Input
            value={sendgridTestEmail}
            onChange={(e) => setSendgridTestEmail(e.target.value)}
            placeholder="test@example.com"
            data-testid="sendgrid-test-email"
          />
          <Button onClick={onTest} disabled={testingSendgrid} variant="outline" data-testid="test-sendgrid-btn">
            {testingSendgrid ? 'Sending...' : 'Send Test'}
          </Button>
        </div>
      </div>
    </CardContent>
  </Card>
);

export default SendgridTab;
